import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import BaseChart from '../baseChart';

HighchartsMore(Highcharts);

export default function BaseChartMore(props) {
  return <BaseChart {...props} />;
}
